export interface Focusable {
  focus(): void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
export function isFocusable(object: any): object is Focusable {
  return 'focus' in object && typeof object.focus === 'function'
}
